var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalesCenter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 884,
    y: 107,
    width: 43,
    height: 43
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 409575,
    height: 409575
  })), /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEsUExURQAAAACAgACA1QCq/ySS2yCf3xeL0RCP3xCf3w+W0g2Z2RaQ0xab3hWV3xSZ1hKV3BCX1w+W2hWV3BWY3RSa3RKU2xGX3BGT1xCY3hCV3xSU2xSZ2xOU2hGX3BCU2hCY2hOY3ROW2hKU2hKV2xGX3ROW2RGV2hGX2xOW2xOV3BOW2ROV2hOX3BKW2xKX2xGW2hOW2ROW2xOV3BKW2xGX2hGW2xOW3RGV2xGU2xKX2xKX3BCV2xKW2hGX2ROW2xKW3BKW2hCV2RCV3BKU2xGW2hKV2hKV3BGV2xGW2xKV2xGX2hKV2xKX2xGU2RGV2hKV2hGW2hOW2xKV2hKW2hGW2RKV2hKV2xGW2xGW2xGW2hGW2hGW2xOW2xKU2xKW2xKV2xKW2xKV2xKW2hKW2y2yhlsAAABjdFJOUwACBgYHCAsQEBEUFxcYGR0gIiQlJissLS8wMjI3Oz4+Q0RFRkxQWVtcXl9gbHBxdXp6e36EhYaTlJqanaews7S4uru9v8HCx8jLzdLS1dja29zf4ufp7vHy9Pb2+Pn5+vv8/Qih7xsAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGoSURBVEhL7ZZXUwIxGEWvDRR7ByvWVREVK6jYG/YuImDJ//8PJutVkwU1+OaM52XvTfbMwE5254Mk6EQscYLqfvjXRAms+aWSZLEkCYTkJRWLWhFLyZtDcITYd3+gFftCOIgIEWO3ICZERClRdguiv1eW2S1YpvI46uPKD/hGH6mUxr/CZM2fUK6Hq2pnnlh0tjsrenaYDeWlSx2jOTaN0yq5XnnMpispZaCFTWPW3Zhm05U9d6eRTWPS3Vhg05Vci9qRnwIvG2q97pbN+PtnvcDgDYvOFNB7wmwqIuvDAaPBIXxZRomhiDAWmQyWEGZSmEocrfJNLaAHcSaFqaSrscKosYXqNKPCVMQ8aq4YP3howzyji0fJd6Mvw0yex9GdZ3bxKOK8HkN3zC7ZCdSfM7/hVcRRAM27zJJUBwJHzKRAEZf9wND6vYqZzZEy9F+6y58UKuIp0QSUt4cHOuQJbkoUvA1FFHnaVsca1LlqGFvNcUmjqKLIXFx4Ht07Xypf868wWRMp9n34HgdBJmvksFTSoCRHJXmS/CWNSkk1XMlhyX6ECwF4BYsF+N11iqciAAAAAElFTkSuQmCC",
    preserveAspectRatio: "none",
    id: "img2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 409575,
    height: 409575
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-884 -107)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    transform: "matrix(0.000104987 0 0 0.000104987 884 107)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#img2",
    transform: "scale(8191.5 8191.5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesCenter);
export default "https://cdn.d2cgo.com/dtc_center/v19/ma_assets/static/media/salesCenter.d1fa82de470b9bb6ec11b9a7b8493281.svg";
export { ForwardRef as ReactComponent };